import './user-card.styles'
import './user-card.scss'

import { BankUser } from '../../../../modules/bank-users/types'
import { Space } from '../..'

export type UserCardProps = {
  isSelected?: boolean
  onClickUser?: (userId: string) => void
  user: BankUser
}

export const BankUserCard = ({ isSelected, onClickUser, user }: UserCardProps) => (
  <Space mt={3}>
    <ul>
      <li className={`${isSelected ? 'user-item-selected' : 'user-item'}`}>
        <Space mx={4} onClick={() => onClickUser(user.userId)}>
          <Space py={4}>
            <div className={`${isSelected ? 'user-item-name-selected' : 'user-item-name'}`}>
              {`${user.firstName} ${user.lastName}`}
            </div>
            <Space
              className={`${isSelected ? 'user-item-role-selected' : 'user-item-role'}`}
              mt={3}
            >
              {user.role}
            </Space>
          </Space>
        </Space>
      </li>
    </ul>
  </Space>
)
